import { create } from 'zustand';
import { fetchLoyaltyBalance } from '../infra/loyaltyApi';
import { redeemPointsToArs, type LoyaltyProgram } from '../domain/loyaltyTypes';

type PosLoyaltyState = {
  customerId: string | null;
  customerName: string | null;
  balance: number;
  program: LoyaltyProgram | null;
  redeemPoints: number;
  setCustomer: (args: { id: string; name: string } | null) => Promise<void>;
  setRedeemPoints: (points: number) => void;
  redeemArsDiscount: () => number;
  clear: () => void;
};

export const usePosLoyaltyStore = create<PosLoyaltyState>((set, get) => ({
  customerId: null,
  customerName: null,
  balance: 0,
  program: null,
  redeemPoints: 0,
  setCustomer: async (args) => {
    if (!args) {
      set({ customerId: null, customerName: null, balance: 0, program: null, redeemPoints: 0 });
      return;
    }
    try {
      const result = await fetchLoyaltyBalance(args.id);
      set({
        customerId: args.id,
        customerName: args.name,
        balance: result.balance,
        program: result.program,
        redeemPoints: 0,
      });
    } catch {
      set({
        customerId: args.id,
        customerName: args.name,
        balance: 0,
        program: null,
        redeemPoints: 0,
      });
    }
  },
  setRedeemPoints: (points) => {
    const bal = get().balance;
    const min = get().program?.minRedeemPoints ?? 1;
    const clamped = Math.max(0, Math.min(Math.floor(points), bal));
    if (clamped > 0 && clamped < min) {
      set({ redeemPoints: 0 });
      return;
    }
    set({ redeemPoints: clamped });
  },
  redeemArsDiscount: () => {
    const { redeemPoints, program } = get();
    if (!program) return 0;
    return redeemPointsToArs(redeemPoints, program.redeemArsPerPoint);
  },
  clear: () =>
    set({ customerId: null, customerName: null, balance: 0, program: null, redeemPoints: 0 }),
}));
